
import { ElForm, ElMessage, ElMessageBox } from 'element-plus'
import { defineComponent, reactive, toRefs, onMounted, ref } from 'vue'
import Container from '@/components/form/container/Container.vue'
import SearchForm from '@/components/form/search/SearchForm.vue'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import CenterForm from '@/components/form/common/CenterForm.vue'
import NomalContainer from '@/components/dfms-components/container/NomalContainer.vue'
import {
  CustomerModel,
  CustomerPageSearchModel,
  CustomerSearchModel,
  CustomerAddModel,
  CustomerUpdateModel,
  IdsModel
} from '@/model/product/CustomerModel'
import {
  pageSearchCustomer,
  addCustomer,
  updateCustomer,
  removeCustomer,
  batchRemoveCustomer
} from '@/apis/product/customer'
import { parseTime } from '@/utils'
import { createModel } from '@/utils/component'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  components: {
    Container,
    SearchForm,
    SimpleTable,
    CenterForm,
    NomalContainer
  },
  setup() {
    const { t } = useI18n()
    const searchFormRef = ref(ElForm)
    const searchStruct = [
      { prop: 'customerName', label: t('customer.customerName'), placeholder: t('customer.customerNameP'), component: 'el-input', type: 'text', model: null }
    ]

    const createStruct = [
      { prop: 'customerName', label: t('customer.customerName'), placeholder: t('customer.customerNameP'), component: 'el-input', type: 'text', model: null }
    ]

    const updateStruct = [
      { prop: 'customerName', label: t('customer.customerName'), placeholder: t('customer.customerNameP'), component: 'el-input', type: 'text', model: null }
    ]

    const customerRole = {
      customerName: [{ required: true, message: t('customer.customerName').concat(t('common.isRequired')), trigger: 'blur' }]
    }

    const tableStruct = [

      { prop: 'customerName', label: t('customer.customerName'), sortable: 'custom' },
      { prop: 'createTime', label: t('common.createTime'), formatter: (row: CustomerModel) => { return parseTime(row.createTime) }, sortable: 'custom' },
      { prop: 'updateTime', label: t('common.updateTime'), formatter: (row: CustomerModel) => { return parseTime(row.updateTime) }, sortable: 'custom' }
    ]
    const dataMap = reactive({
      searchFormStruct: searchStruct,
      searchFormModel: createModel(searchStruct) as CustomerSearchModel,
      tableData: Array<CustomerModel>(),
      columnStruct: tableStruct,
      listLoading: true,
      selection: Array<number>(),
      limit: 10,
      total: 0,
      page: 1,
      sort: 'createTime',
      order: 'desc',
      dialogStatus: 'create',
      textMap: {
        update: 'customer.edit',
        create: 'customer.create'
      },
      dialogFormVisible: false,
      customerRole: customerRole,
      createStruct: createStruct,
      createModel: createModel(createStruct) as CustomerAddModel,
      updateStruct: updateStruct,
      updateModel: createModel(updateStruct) as CustomerUpdateModel,
      editRow: {} as CustomerModel,
      handleSelection(item: any[]) {
        dataMap.selection = item
      },
      handleCurrentChange(page?: any) {
        dataMap.page = page
        dataMap.getList()
      },
      handleSizeChange(val: any) {
        dataMap.limit = val
        dataMap.getList()
      },
      handleOrder(column: any) {
        dataMap.sort = column.prop
        dataMap.order = column.order === 'descending' ? 'desc' : 'asc'
        dataMap.getList()
      },
      async getList() {
        dataMap.listLoading = true
        const params: CustomerPageSearchModel = {
          customerName: dataMap.searchFormModel.customerName,
          page: dataMap.page,
          limit: dataMap.limit,
          sort: dataMap.sort,
          order: dataMap.order
        }
        const data = await pageSearchCustomer(params)
        dataMap.tableData = data?.data?.records ?? []
        const total = data?.data?.total ?? '0'
        dataMap.total = parseInt(total)

        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      },
      submitSearch() {
        dataMap.page = 1
        dataMap.getList()
      },
      resetForm() {
        console.log('reset')
      },
      async createSubmit() {
        const createData: CustomerAddModel = {
          customerName: dataMap.createModel.customerName
        }
        const result = await addCustomer(createData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.createSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async updateNameSubmit() {
        const updateData: CustomerUpdateModel = {
          id: dataMap.updateModel.id,
          customerName: dataMap.updateModel.customerName
        }
        const result = await updateCustomer(updateData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.updateSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async deleteData(id: number) {
        const result = await removeCustomer(id)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async bathDeleteData() {
        const deleteData: IdsModel = { ids: dataMap.selection }
        const result = await batchRemoveCustomer(deleteData)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      updateNameReset() {
        console.log('update reset')
        dataMap.updateModel.id = dataMap.editRow.id
        dataMap.updateModel.customerName = dataMap.editRow.customerName
      },
      createReset() {
        console.log('create reset')
      }
    })
    const handleCreate = () => {
      dataMap.dialogStatus = 'create'
      dataMap.dialogFormVisible = true
    }
    const handleEdit = (row?: CustomerModel) => {
      if (row) {
        dataMap.editRow = row
        dataMap.dialogStatus = 'update'
        dataMap.updateModel.id = row.id
        dataMap.updateModel.customerName = row.customerName
        dataMap.dialogFormVisible = true
      }
    }
    const handleDelete = (id: number) => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.deleteData(id)
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    const handleBathDelete = () => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.bathDeleteData()
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    onMounted(() => {
      dataMap.getList()
    })
    return {
      t,
      handleCreate,
      handleEdit,
      handleDelete,
      handleBathDelete,
      searchFormRef,
      ...toRefs(dataMap)
    }
  }
})
